// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ethical-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);
}

.ethical-container {
  flex: 1 1;
  max-width: 900px;
  margin: 0 auto;
  padding: 4rem 2rem;
  width: 100%;
}

.ethical-title {
  font-size: 2.75rem;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 3rem;
  line-height: 1.2;
}

.ethical-content {
  background-color: #ffffff;
  border-radius: 1rem;
  padding: 3rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.ethical-intro {
  font-size: 1.25rem;
  color: #0f172a;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.ethical-text {
  font-size: 1.1rem;
  color: #475569;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}

.ethical-highlight {
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 1.5rem;
  margin: 2rem 0;
  border-radius: 0.5rem;
}

.ethical-highlight p {
  font-size: 1.1rem;
  color: #0f172a;
  line-height: 1.8;
  margin: 0;
}

.ethical-highlight strong {
  color: #856404;
}

.ethical-feature {
  margin: 2.5rem 0;
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 0.75rem;
  border: 1px solid #e2e8f0;
}

.feature-heading {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1rem;
}

.ethical-notice {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin: 2.5rem 0;
  text-align: center;
}

.ethical-notice p {
  font-size: 1rem;
  color: #0c5460;
  font-weight: 600;
  margin: 0;
  font-style: italic;
}

.ethical-guidelines {
  margin: 3rem 0;
  padding: 2.5rem;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.guidelines-heading {
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1.5rem;
  text-align: center;
}

.guidelines-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.guidelines-list li {
  padding: 1rem 0 1rem 2rem;
  color: #475569;
  font-size: 1.05rem;
  line-height: 1.7;
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.guidelines-list li:last-child {
  border-bottom: none;
}

.guidelines-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #28a745;
  font-weight: 700;
  font-size: 1.3rem;
}

.guidelines-list strong {
  color: #0f172a;
  font-weight: 600;
}

.ethical-commitment {
  margin-top: 3rem;
  padding: 2.5rem;
  background-color: #f8f9fa;
  border-radius: 1rem;
  border: 2px solid #28a745;
}

.commitment-heading {
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1.5rem;
  text-align: center;
}

.ethical-commitment .ethical-text {
  margin-bottom: 1rem;
}

.ethical-commitment strong {
  color: #28a745;
}

/* Responsive Design */
@media (max-width: 768px) {
  .ethical-container {
    padding: 3rem 1.5rem;
  }
  
  .ethical-title {
    font-size: 2rem;
  }
  
  .ethical-content {
    padding: 2rem 1.5rem;
  }
  
  .ethical-intro {
    font-size: 1.1rem;
  }
  
  .ethical-text {
    font-size: 1rem;
  }
  
  .feature-heading,
  .guidelines-heading,
  .commitment-heading {
    font-size: 1.5rem;
  }
  
  .ethical-guidelines {
    padding: 2rem 1.5rem;
  }
  
  .ethical-commitment {
    padding: 2rem 1.5rem;
  }
  
  .guidelines-list li {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .ethical-container {
    padding: 2rem 1rem;
  }
  
  .ethical-title {
    font-size: 1.75rem;
    margin-bottom: 2rem;
  }
  
  .ethical-content {
    padding: 1.5rem 1rem;
  }
  
  .ethical-intro {
    font-size: 1rem;
  }
  
  .ethical-text {
    font-size: 0.95rem;
  }
  
  .ethical-highlight,
  .ethical-feature,
  .ethical-guidelines,
  .ethical-commitment {
    padding: 1.5rem 1rem;
  }
  
  .feature-heading,
  .guidelines-heading,
  .commitment-heading {
    font-size: 1.3rem;
  }
  
  .guidelines-list li {
    font-size: 0.95rem;
    padding-left: 1.5rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/components/EthicalUsage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,oBAAoB;EACtB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF","sourcesContent":[".ethical-page {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);\n}\n\n.ethical-container {\n  flex: 1;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 4rem 2rem;\n  width: 100%;\n}\n\n.ethical-title {\n  font-size: 2.75rem;\n  font-weight: 700;\n  color: #0f172a;\n  text-align: center;\n  margin-bottom: 3rem;\n  line-height: 1.2;\n}\n\n.ethical-content {\n  background-color: #ffffff;\n  border-radius: 1rem;\n  padding: 3rem;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.ethical-intro {\n  font-size: 1.25rem;\n  color: #0f172a;\n  line-height: 1.8;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.ethical-text {\n  font-size: 1.1rem;\n  color: #475569;\n  line-height: 1.8;\n  margin-bottom: 1.5rem;\n}\n\n.ethical-highlight {\n  background-color: #fff3cd;\n  border-left: 4px solid #ffc107;\n  padding: 1.5rem;\n  margin: 2rem 0;\n  border-radius: 0.5rem;\n}\n\n.ethical-highlight p {\n  font-size: 1.1rem;\n  color: #0f172a;\n  line-height: 1.8;\n  margin: 0;\n}\n\n.ethical-highlight strong {\n  color: #856404;\n}\n\n.ethical-feature {\n  margin: 2.5rem 0;\n  padding: 2rem;\n  background-color: #f8f9fa;\n  border-radius: 0.75rem;\n  border: 1px solid #e2e8f0;\n}\n\n.feature-heading {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1rem;\n}\n\n.ethical-notice {\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  margin: 2.5rem 0;\n  text-align: center;\n}\n\n.ethical-notice p {\n  font-size: 1rem;\n  color: #0c5460;\n  font-weight: 600;\n  margin: 0;\n  font-style: italic;\n}\n\n.ethical-guidelines {\n  margin: 3rem 0;\n  padding: 2.5rem;\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  border-radius: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.guidelines-heading {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.guidelines-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.guidelines-list li {\n  padding: 1rem 0 1rem 2rem;\n  color: #475569;\n  font-size: 1.05rem;\n  line-height: 1.7;\n  position: relative;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.guidelines-list li:last-child {\n  border-bottom: none;\n}\n\n.guidelines-list li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: #28a745;\n  font-weight: 700;\n  font-size: 1.3rem;\n}\n\n.guidelines-list strong {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.ethical-commitment {\n  margin-top: 3rem;\n  padding: 2.5rem;\n  background-color: #f8f9fa;\n  border-radius: 1rem;\n  border: 2px solid #28a745;\n}\n\n.commitment-heading {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.ethical-commitment .ethical-text {\n  margin-bottom: 1rem;\n}\n\n.ethical-commitment strong {\n  color: #28a745;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .ethical-container {\n    padding: 3rem 1.5rem;\n  }\n  \n  .ethical-title {\n    font-size: 2rem;\n  }\n  \n  .ethical-content {\n    padding: 2rem 1.5rem;\n  }\n  \n  .ethical-intro {\n    font-size: 1.1rem;\n  }\n  \n  .ethical-text {\n    font-size: 1rem;\n  }\n  \n  .feature-heading,\n  .guidelines-heading,\n  .commitment-heading {\n    font-size: 1.5rem;\n  }\n  \n  .ethical-guidelines {\n    padding: 2rem 1.5rem;\n  }\n  \n  .ethical-commitment {\n    padding: 2rem 1.5rem;\n  }\n  \n  .guidelines-list li {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .ethical-container {\n    padding: 2rem 1rem;\n  }\n  \n  .ethical-title {\n    font-size: 1.75rem;\n    margin-bottom: 2rem;\n  }\n  \n  .ethical-content {\n    padding: 1.5rem 1rem;\n  }\n  \n  .ethical-intro {\n    font-size: 1rem;\n  }\n  \n  .ethical-text {\n    font-size: 0.95rem;\n  }\n  \n  .ethical-highlight,\n  .ethical-feature,\n  .ethical-guidelines,\n  .ethical-commitment {\n    padding: 1.5rem 1rem;\n  }\n  \n  .feature-heading,\n  .guidelines-heading,\n  .commitment-heading {\n    font-size: 1.3rem;\n  }\n  \n  .guidelines-list li {\n    font-size: 0.95rem;\n    padding-left: 1.5rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
